export const dbTabs2 = {
  ageRules: {
    heading: "Zasady dotyczące gości",
    headHint:
      "Określ, kto liczy się jako niemowlę, dziecko i osoba dorosła oraz jak wpływają na pojemność {scope}. Domyślnie niemowlęta nie zajmują miejsca i nie są rozliczane.",
    scopeHotel: "każdego pokoju",
    scopeApartment: "obiektu",
    loading: "Wczytywanie zasad…",
    emptyHotel: "Ten hotel nie ma skonfigurowanych pokoi.",
    capacityChipTitle: "Pojemność pokoju (ustawiana w sekcji Pojemność)",
    slots: "{count} miejsce | {count} miejsca | {count} miejsc",
    badgeCustom: "Własne",
    badgeStandard: "Standardowe",
    applyAgeRules: "Zastosuj zasady wiekowe",
    masterSubHotel: "Własne ustawienia niemowląt, dzieci i pojemności dla tego pokoju.",
    masterSubApartment: "Własne ustawienia niemowląt, dzieci i pojemności dla tego obiektu.",
    standardNote:
      "Zachowanie standardowe: niemowlęta nie wliczają się do pojemności i nie są rozliczane.",
    capacityLabel: "Pojemność",
    capacityGuestsNote:
      'gość · ustawiane w sekcji "Pojemność"; te zasady zmieniają tylko to, kto się liczy | goście · ustawiane w sekcji "Pojemność"; te zasady zmieniają tylko to, kto się liczy | gości · ustawiane w sekcji "Pojemność"; te zasady zmieniają tylko to, kto się liczy',
    infantUpTo: "Niemowlęta to dzieci do",
    years: "lat",
    childToAdult: "Dziecko staje się osobą dorosłą w wieku",
    maxInfants: "Maksymalna liczba niemowląt",
    perBooking: "na rezerwację",
    infantsOccupy: "Niemowlęta zajmują miejsce",
    infantsCharged: "Niemowlęta są rozliczane",
    childrenCount: "Dzieci liczą się jako gość",
    ageLegend:
      "Niemowlę: poniżej {infant} lat · Dziecko: {infant}–{childTo} lat · Osoba dorosła: {adult}+ lat.",
    listingCapacity: "Pojemność oferty",
    listingCapacityHint: 'Ustawiana w sekcji "Pojemność" i wspólna z sekcją "Obłożenie".',
    thisAccommodation: "Ten obiekt",
    loadError: "Nie udało się wczytać zasad dotyczących gości.",
    saveSuccess: "Zasady dotyczące gości zostały zapisane.",
    saveError: "Nie udało się zapisać zasad dotyczących gości.",
  },
  globalPayments: {
    title: "Płatności globalne (apartamenty/wille)",
    pill: "Globalne",
    desc: "To ustawienie dotyczy wszystkich obiektów typu apartament/willa należących do użytkownika.",
    loading: "Wczytywanie ustawień…",
    paymentType: "Rodzaj płatności",
    onArrivalLabel: "Płatność na miejscu",
    onArrivalDesc: "Gość rezerwuje i płaci bezpośrednio po przyjeździe.",
    onlineLabel: "Płatność online",
    onlineDesc: "Gość płaci online podczas finalizowania rezerwacji.",
    savedAtUserLevel: "Zapisane na poziomie użytkownika dla apartamentów/willi.",
    globalDiscount: "Rabat globalny",
    enableGlobalDiscount: "Włącz rabat globalny",
    discountType: "Rodzaj rabatu",
    percentageLabel: "Procentowy",
    percentageDesc: "Rabat proporcjonalny do sumy.",
    fixedLabel: "Stały",
    fixedDesc: "Stała kwota do odliczenia.",
    valueTitle: "Wartość",
    phPercentage: "np. 10",
    phFixed: "np. 15.00",
    helpPercentage: "Maksymalnie 100%. Stosowany do sumy.",
    helpFixed: "Odliczana jest stała kwota w {currency}.",
    previewTitle: "Podgląd",
    previewPercentage: "Zostanie zastosowany globalny rabat {percent}%.",
    previewFixed: "Zostanie zastosowany globalny rabat {amount}.",
    appliesAllDirect: "Dotyczy wszystkich rezerwacji bezpośrednich apartamentów/willi.",
    saveSuccess: "Płatności globalne zapisane.",
    saveError: "Nie udało się zapisać płatności globalnych.",
  },
  payments: {
    loading: "Wczytywanie ustawień…",
    q02Title: "Kiedy gość płaci?",
    savingBadge: "Zapisywanie…",
    payOnArrivalName: "Płatność na miejscu",
    payOnArrivalHint: "Gość rezerwuje i płaci bezpośrednio po przyjeździe.",
    payOnlineName: "Płatność online",
    payOnlineHint: "Gość płaci online podczas finalizowania rezerwacji.",
    q03Title: "Czas na płatność",
    onlineOnlyBadge: "Tylko płatność online",
    holdDesc:
      "Kalendarz jest zablokowany, dopóki gość nie dokończy płatności.<br>Jeśli nie zapłaci w wyznaczonym czasie, <strong>dostępność zostaje zwolniona automatycznie</strong>.",
    unitMin: "min",
    unitHour: "godzina",
    unitHours: "godziny",
    q04Title: "Płatność częściowa",
    partialTitle: "Zezwól na opłacenie tylko części przy rezerwacji",
    partialOnDesc:
      "<strong>Włączone.</strong> Gość może zapłacić teraz <strong>{percent}%</strong>, a resztę przed przyjazdem (albo zapłacić całość).",
    partialOffDesc:
      "<strong>Wyłączone.</strong> Gość płaci <strong>całą kwotę</strong> przy rezerwacji.",
    blockTitle: "Resztę gość płaci w obiekcie",
    blockOnDesc:
      "<strong>Włączone.</strong> Gość płaci online <strong>tylko {percent}%</strong>; resztę reguluje <strong>po przyjeździe</strong> (nie może zapłacić całości online).",
    blockOffDesc:
      "<strong>Wyłączone.</strong> Gość może wybrać, czy zapłaci online {percent}%, czy całą kwotę.",
    q05Title: "Przypomnienie o dopłacie",
    reminderTitle: "Wyślij przypomnienie o opłaceniu pozostałej kwoty",
    reminderOnDesc:
      "<strong>Włączone.</strong> <strong>{when}</strong> przyjazdem (około 09:00 czasu obiektu) gość otrzymuje link do opłacenia pozostałej kwoty przez <strong>WhatsApp i e-mail</strong>.",
    reminderOffDesc:
      "<strong>Wyłączone.</strong> Gość nie otrzymuje przypomnienia o opłaceniu pozostałej kwoty online przed przyjazdem.",
    daysBefore: "{count} dzień przed | {count} dni przed | {count} dni przed",
    reminderDaysLabel: "Dni przed przyjazdem",
    reminderHint:
      "Wysyłane raz i tylko do gości z pozostałą kwotą do zapłaty. Jeśli reszta jest płacona w obiekcie, przypomnienie nie jest wysyłane.",
    approveTitle: "Zatwierdzanie rezerwacji",
    approveCardTitle: "Zatwierdzaj każdą rezerwację przed jej potwierdzeniem",
    approveOnDesc:
      "<strong>Włączone.</strong> Każda rezerwacja czeka <strong>na zatwierdzenie</strong>: przychodzi powiadomienie i można zdecydować, czy ją przyjąć, czy odrzucić. Nie zostaje potwierdzona, dopóki nie zostanie zatwierdzona.",
    approveOffDesc:
      "<strong>Wyłączone.</strong> Rezerwacje <strong>potwierdzają się same</strong> po zakończeniu płatności. Włącz tę opcję, jeśli wolisz samodzielnie sprawdzać i zatwierdzać każdą prośbę.",
    saveSuccess: "Zapisano.",
    saveError: "Nie udało się zapisać zmian.",
  },
  unitConfig: {
    descByRoom: "Opis dla każdego pokoju",
    descByRoomHint:
      "Każdy pokój ma własny opis i własną widoczność w rezerwacji bezpośredniej.",
    loadingRooms: "Wczytywanie pokoi…",
    emptyHotel: "Ten hotel nie ma skonfigurowanych pokoi.",
    visible: "Widoczny",
    hidden: "Ukryty",
    roomDescPlaceholder: "Opisz pokój {name} (łóżka, udogodnienia, widoki…)",
    savingDesc: "Zapisywanie…",
    autosaveHint: "Zapisywane automatycznie po opuszczeniu pola.",
    loadingProperty: "Wczytywanie danych obiektu…",
    loadErrorProperty: "Nie udało się wczytać ustawień tego obiektu.",
    amenitiesByRoom: "Udogodnienia w każdym pokoju",
    amenitiesByRoomHint:
      "Każdy pokój może oferować inne udogodnienia. Rezerwacja bezpośrednia i Agent AI korzystają z udogodnień pokoju przypisanego gościowi.",
    amenitiesCount: "{count} udogodnienie | {count} udogodnienia | {count} udogodnień",
    noAmenities: "Brak udogodnień",
    titleDescription: "Opis obiektu",
    titleServices: "Wyposażenie i udogodnienia",
    subtitleDescription:
      "Edytuj opis, który goście zobaczą na stronie rezerwacji bezpośrednich.",
    subtitleServices: "Zaznacz, co oferuje ten obiekt, i dodaj zdjęcia.",
  },
};
